import styled from 'styled-components/macro';
import { UtilityText } from 'components/Typography';

export const AlertBellWrapper = styled.button`
  border: none;
  background: transparent;
  padding: 0;
  font: inherit;
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: pointer;

  &:hover span {
    opacity: 1;
    visibility: visible;
  }
`;

export const TooltipText = styled(UtilityText)`
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 8px;
  padding: 8px 12px;
  background: ${({ theme }) => theme.colors.inkBlue};
  color: ${({ theme }) => theme.colors.white};
  border-radius: 4px;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.15s ease;
  z-index: 10;
`;
